export const epoqRecomputePrices = (prj, recomputedData) => {

    /*if(!prj.discountamount)
        prj.discountamount = 0;

    prj.delivery.countrycode = prj.shippingaddress[0].countrycode || prj.orderaddress[0].countrycode || 'NO'
    prj.delivery.postalcode = prj.shippingaddress[0].postalcode || prj.orderaddress[0].postalcode
    prj.delivery.chain = this.chain;
    prj.priceDate = (new Date()).toInt();*/

    return new Promise((resolve, reject) => {
        // Recalculate prices for elkjop
        prj.rows.forEach(r => {

            // Ignore wall items
            if (r.wallItem)
                return

            // Substitute BOM & BOP in current ERP
            for (let i = 0; i < r.erp.length; i++) {
                let erp = r.erp[i]
//                                let newErp = r.erp[i];
                erp.sctot = 0

                if (erp.camp.length > 0) {
                    // console.log(e0.camp);
                    for (let j = 0; j < erp.camp.length; j++) {
                        erp.sctot += erp.camp[j].value
                    }
                }
            }

            // Add images
            let jsonRow = recomputedData.rows.filter( jr => { return jr.uniqueid === r.uniqueid });
            if(jsonRow && jsonRow[0])
                r.img = jsonRow[0].img;

        })
        resolve()
    })
}



// WEBPACK FOOTER //
// ./src/custom/epoq/_modules/EpoqStatic.js